angular.module('autoremind.satellites')
    .directive('satelliteErrors', ['$location', '$interval', 'satelliteService',
    function ($location, $interval, satelliteService) {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/satellites/satellite-errors.html',
            scope: {
                parentViewModel: '=',
                activated: '='
            },
            link: function ($scope, element, attrs) {
                $scope.viewModel = $scope.parentViewModel.tabViews.errors;
                $scope.viewModel.fetchState = {
                    buttonLabel: "Refresh",
                    busy: false
                };
                $scope.getLogEvents = function () {
                    $scope.viewModel.satelliteErrorSort = { column: "eventId", descending: true };
                    // Get user just in case selection was made without router initializing controller again
                    if (!angular.isDefined($scope.viewModel.lastLogEventId)) {
                        $scope.viewModel.lastLogEventId = 0;
                        $scope.viewModel.logEvents = [];
                        $scope.viewModel.firstLogEventId = 0;
                    }
                    $scope.viewModel.logEventLoadingIndicator = true;
                    delete $scope.viewModel.afterLoadMessage;
                    satelliteService.getLogEventsByUser($scope.viewModel.selectedUserName, $scope.viewModel.lastLogEventId, $scope.viewModel.firstLogEventId, $scope.parentViewModel.loadingIndicator)
                        .then(function (data) {
                        $scope.viewModel.logEventLoadingIndicator = false;
                        if ($scope.viewModel.logEvents.length === 0) {
                            $scope.viewModel.logEvents = data.events;
                        }
                        else {
                            // Append new events
                            for (var i = 0; i < data.events.length; i++) {
                                $scope.viewModel.logEvents.push(data.events[i]);
                            }
                        }
                        if (data.events !== undefined && data.events.length !== 0) {
                            $scope.viewModel.lastLogEventId = data.lastLogEventId;
                            $scope.viewModel.firstLogEventId = $scope.viewModel.firstLogEventId === 0 || $scope.viewModel.firstLogEventId < data.events[0].eventId ? data.events[0].eventId : $scope.viewModel.firstLogEventId;
                        }
                        if ($scope.viewModel.logEvents.length === 0) {
                            $scope.viewModel.afterLoadMessage = 'No events for this satellite';
                        }
                        // TODO: Get only new since the latest event ID we got the last time and add to the list
                    }, function () {
                        $scope.viewModel.logEventLoadingIndicator = false;
                    });
                };
                $scope.toggleSelectedRow = function (next) {
                    if ($scope.viewModel.selectedLogEvent === next) {
                        $scope.viewModel.selectedLogEvent = null;
                        return;
                    }
                    $scope.viewModel.selectedLogEvent = next;
                };
                $scope.init = function () {
                    $scope.getLogEvents(0);
                };
                $scope.hasBeenActivatedOnce = false;
                $scope.$watch('activated', function (newActivated, oldActivated) {
                    if (newActivated && !$scope.hasBeenActivatedOnce) {
                        $scope.hasBeenActivatedOnce = true;
                        $scope.viewModel.selectedUserName = $location.search().user;
                        if ($scope.viewModel.selectedUserName) {
                            $scope.init();
                        }
                    }
                });
                // "observe" when user is fully loaded (because we need userName - not only userId)
                $scope.$watch('parentViewModel.selectedUserInfo', function (newUser, oldUser) {
                    if (newUser && newUser !== oldUser) {
                        // The loading indicator should be updated as soon we change/search user
                        if (oldUser && newUser.userId !== oldUser.userId) {
                            $scope.viewModel.logEventLoadingIndicator = true;
                            $scope.viewModel.lastLogEventId = 0;
                            $scope.viewModel.firstLogEventId = 0;
                            $scope.viewModel.logEvents = [];
                            delete $scope.viewModel.afterLoadMessage;
                        }
                        if ($scope.activated && !$scope.viewModel.selectedUserName) {
                            $scope.viewModel.selectedUserName = newUser.userName;
                            $scope.init();
                        }
                    }
                });
            }
        };
    }]);
//# sourceMappingURL=satellite-errors.directive.js.map